import qs from "qs";

import {
  OAUTH_CLIENT_ID,
  FRONTEND_ROOT,
  BACKEND_ROOT,
} from "../config/constants";

// Build auth URL as query string
const authObj = {
  client_id: OAUTH_CLIENT_ID,
  redirect_uri: encodeURI(`${FRONTEND_ROOT}/authorize`),
  scope: "read write",
  response_type: "token",
  state: Date.now(),
};

export const AUTH_URL = `${BACKEND_ROOT}/o/authorize/?${qs.stringify(authObj)}`;
